import { defaultTo } from 'ramda';
import { IBuyCustomPackageResponse } from '../../../repositories/billing-service-packages-balancer/v4/buy-custom-package';
import { ECode } from '../../../repositories/billing-service-packages-balancer/entities/Purchase/AddServicePackageV2Response';
import { IBuyPackageResult } from '../../../thunks/runBuyPackageLegacy/afterPurchasingPackage';

export const mapResponse200 = (response: IBuyCustomPackageResponse): IBuyPackageResult => {
  switch (response.code) {
    case ECode.Ok:
      return { isSuccess: true };

    case ECode.NotEnoughMoney:
      return {
        isSuccess: false,
        amount: defaultTo(0, response.balanceDetails?.notEnough),
      };

    default:
      return { isSuccess: false };
  }
};
